{
  "update": "A new version of CloudServer is available.",
  "reload": "Update"
}
